import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Loader from '../Utility/Loader/Loader';

function CustomButtonPopup({ onOpen, message, toggle, title, loading }) {
  return (
    <Modal show={onOpen} backdrop="static" className="common-custom-modal modal-small" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{title}</span>
          </Modal.Title>
          <span onClick={toggle} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <span>
            <p className="mb-2">{message}</p>
          </span>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default CustomButtonPopup;
